import { IconArrowDown } from './Down';
import { IconArrowExchange } from './Exchange';
import { IconArrowLeft } from './Left';
import { IconArrowRight } from './Right';
import { IconArrowUp } from './Up';
import { IconArrowUpRight } from './UpRight';
export const IconArrow = {
    ArrowDown: IconArrowDown,
    ArrowExchange: IconArrowExchange,
    ArrowLeft: IconArrowLeft,
    ArrowRight: IconArrowRight,
    ArrowUp: IconArrowUp,
    ArrowUpRight: IconArrowUpRight,
};
//# sourceMappingURL=index.js.map